import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_LARGE } from '~/constants';

import { unique } from '@vestigas/utils';

import {
  zodContractDataSourceSchema,
  zodContractStatusSchema,
} from '../validations';

import { CONTRACT_SORT_FIELDS } from './constants';

// Re-export shared validations used by this hook
export {
  zodContractListItemSchema,
  zodContractsDetailsListResponseSchema,
  zodContractsListResponseSchema,
} from '../validations';

export const zodContractsQueryParamsSchema = z.object({
  accountingReferenceIds: z
    .array(z.uuid())
    .optional()
    .catch(undefined)
    .transform((data) =>
      Array.isArray(data) ? unique(data).filter(Boolean).toSorted() : data,
    ),
  buyerCompanyId: z.uuid().optional().catch(undefined),
  contractId: z.uuid().optional().catch(undefined),
  dataSource: zodContractDataSourceSchema.optional().catch(undefined),
  // true: only contracts with a customer contract number; false: only those
  // without one. A blank number counts as missing.
  hasBuyerAssignedId: z.boolean().optional().catch(undefined),
  // true: only IDS shop orders; false: only contracts that are not IDS shop orders.
  hasIdsOrder: z.boolean().optional().catch(undefined),
  // The API leaves out drafts nobody has put anything into unless this is
  // true; a contract requested by contractId is returned either way.
  includeUnsaved: z.boolean().optional().catch(undefined),
  limit: z.number().int().min(1).max(500).default(PAGINATION_PAGE_SIZE_LARGE),
  offset: z.number().int().min(0).default(0),
  page: z.coerce.number().int().nonnegative().optional().default(0).catch(0),
  searchString: z.string().trim().optional(),
  sellerCompanyId: z.uuid().optional().catch(undefined),
  siteIds: z
    .array(z.uuid())
    .optional()
    .catch(undefined)
    .transform((data) =>
      Array.isArray(data) ? unique(data).filter(Boolean).toSorted() : data,
    ),
  sortBy: z.enum(CONTRACT_SORT_FIELDS).optional().catch(undefined),
  sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
  status: z.array(zodContractStatusSchema).optional().catch(undefined),
  // 'extended' returns full contracts, every item embedded; list views must
  // not use it.
  view: z.literal('extended').optional().catch(undefined),
});
